import ProductCard from './ProductCard'
import React, { FC, useRef } from "react";
import { useQuery } from '@hooks/useRouter'
import { useAtomValue } from 'jotai';
import { listViewLayoutAtom } from 'atoms/list-view-layout';
import './styles.css'

interface ProductListProps {
  products: any[]
}

const ProductList: FC<ProductListProps> = ({ products, ...props }) => {
  const ref = useRef(null)
  const query = useQuery()

  const count = useAtomValue(listViewLayoutAtom)

  const classNames = count == 1 ? 'tw-basis-full' : "tw-basis-1/2 md:tw-basis-1/3 lg:tw-basis-1/4"

  return products.map((product, i) => <div className={classNames} key={i}>
    <div className='tw-m-3'>
      <ProductCard
        id={product.id}
        skuId={product.skuId}
        titles={product.titles}
        cover={product.platform === 'tmall' ? (product.thumbnails[1] ?? product.cover) : product.cover}
        thumbnails={product.thumbnails}
        sold={product.sold}
        originalPrice={product.minPrice}
        platform={product.platform}
        sellerId={product.seller?.id}
        unavailable={product.unavailable}
        prettyUpImage={props.prettyUpImage}
        renderThumbnails={props.renderThumbnails}
        hideDiscount={props.hideDiscount}
        ref={ref}
        {...product.location && {
          location: [product.location.state, product.location.city],
        }}
        {...product.promotion &&
        product.promotion.minPrice && {
          discountPrice: product.promotion.minPrice,
        }}
        {...query.at && { affiliateToken: query.at }}
        {...query.via && { affiliateVia: query.via }}
      />

    </div>
  </div>
  )
}

ProductList.defaultProps = {
  products: [],

  renderThumbnails: true,
  prettyUpImage: true,
}

export default ProductList
